/**
 * Request for `POST api/TutorReport/RunPlacementSearch`.
 *
 * Paging is opt-in (Plans/table-lazy-loading.md §4 A1): `view-student-bookings.component.ts` and
 * both `session-overview` call sites post this request with the paging fields left undefined and
 * must keep receiving today's full, unpaged array. Only `placement-search.component.ts` sets
 * `paged`/`pageNumber`/etc, via `PlacementService.searchPlacements`'s second argument, and receives
 * the `PagedResponse<SearchPlacementResult>` envelope instead.
 */
export class SearchPlacementRequest {
    clientName: string;
    bookingId: string;
    searchTerm: string;
    pendingSetupOnly: boolean;
    showEnded: boolean;
    clientIds: Array<number>;
    attachSessions: boolean = false;
    attachStudents: boolean = false;
    dateFrom?: Date;
    dateTo?: Date;
    /** Brands to restrict to; empty or absent means every brand the user may see. */
    companyIds?: number[];
    /**
     * Booking search only, and only while filters.booking-search is on: "Online" / "In person",
     * "AP" / "SP", and a start-date window (yyyy-MM-dd). Null means no filter.
     */
    deliveryMode?: string;
    provisionType?: string;
    startFrom?: string;
    startTo?: string;

    /** Set only when opting into server-side paging - see the class comment above. */
    paged?: boolean;
    pageNumber?: number;
    pageSize?: number;
    sortField?: string;
    sortDirection?: string;

    constructor() {}
}